<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.index,
                    },
                    {
                        name: survey.title,
                        href: null,
                    },
                    {
                        name: report.date_display,
                        href: meta.links.show,
                    },
                ]"
            />
        </template>
        <div>
            <SurveyReport :survey="survey" :report="report" />
        </div>
        <div>
            <SurveyAnswerCommentsList :comments="comments" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SurveyAnswerCommentsList from '../../../Teacher/Surveys/GroupReports/AnswerComments/SurveyAnswerCommentsList.vue';
import SurveyReport from '../../../Teacher/Surveys/GroupReports/partials/SurveyReport.vue';

export default {
    components: {
        SurveyAnswerCommentsList,
        SurveyReport,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'survey', 'report', 'comments'],
    data() {
        return {
            form: this.$inertia.form({
                comment: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
